module.exports = __webpack_public_path__ + "static/media/IMG_20161024_211626_edited.9ff8a1df.jpg";